import { uploadPhoto } from "../services/files";
import { compressBase64Image } from "./filesToBase64";

export async function replaceSrcInImgTags(htmlString) {
    const imgTags = htmlString.match(/<img\b[^>]*>/gi);

    if (!imgTags) {
        // No img tags found
        return htmlString;
    }

    let modifiedHtmlString = htmlString;
    const promises = [];

    await Promise.all(imgTags.map(async function (imgTag) {
        const srcMatch = imgTag.match(/src\s*=\s*(['"])(.*?)\1/);

        if (!srcMatch) {
            return;
        }

        const src = srcMatch[2];

        if (isUrl(src)) {
            // Skip processing if the src is already a URL
            return;
        }
        const compress64Image = await compressBase64Image(src, 0.5);
        // Call uploadImage API with the base64 src
        const uploadPromise = uploadPhoto(compress64Image)
            .then(function (url) {
                // Replace the src in the modified HTML string with the returned URL
                const modifiedImgTag = imgTag.replace(src, url.data);
                modifiedHtmlString = modifiedHtmlString.replace(imgTag, modifiedImgTag);
            });

        promises.push(uploadPromise);
    }))

    // Wait for all uploadImage promises to resolve
    return Promise.all(promises)
        .then(function () {
            return modifiedHtmlString;
        });
}

// Example function to check if a string is a URL
function isUrl(str) {
    // Replace this with your actual URL validation logic
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlRegex.test(str);
}